import { createApp } from 'vue'
import { globalMixin } from './globalMixins';
import App from './App.vue'
import router from './router'


import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import '@/assets/scss/globalColors.scss';
import '@/assets/css/global.css';

const app = createApp(App);

app.mixin(globalMixin);
app.use(router).mount('#app')
